/**
 * 渲染React页面
 */
import '../style';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ErrorBoundaryPage } from '../component/ErrorBoundary';

// 统一保证在业务代码之前运行 fixReferrer()
import '../util-lib/fix-referrer';

export default function render(PageComponent, store = {}, cb) {
  ReactDOM.render(
    <ErrorBoundaryPage key="error">
      {
        store.dispatch instanceof Function
          ? (
            <Provider store={store}>
              <PageComponent />
            </Provider>
          )
          : (<PageComponent {...store} />)
      }
    </ErrorBoundaryPage>,
    document.getElementById('react-app'),
    () => {
      hideInitLoading();
      cb && cb();
    }
  );
}


export function hideInitLoading() {
  const node = document.getElementById('react-app-init-loading');
  const parentNode = getParentNode(node);
  if (parentNode) {
    parentNode.removeChild(node);
  }
}


function getParentNode(node) {
  if (!node) return null;

  return node.parentNode || node.parentElement;
}
